import Action from 'redux/helpers/createAction'
const name = 'serpChecker'

export const getResults = Action(name + '/GET_RESULTS')

export const getSerpCheckerResults = Action(name + '/GET_SERP_CHECKER_RESULTS')

export const getSerpCheckerResultsSuccess = Action(
  name + '/GET_SERP_CHECKER_RESULTS_SUCCESS',
  data => ({
    data
  })
)

export const getSerpCheckerResultsFailure = Action(
  name + '/GET_SERP_CHECKER_RESULTS_FAILURE',
  error => ({
    error
  })
)

export const setKeyword = Action(
  name + '/SET_KEYWORD',
  keyword => ({
    keyword
  })
)

export const getSerpCheckerResultsNotReady = Action(
  name + '/GET_SERP_CHECKER_RESULTS_NOT_READY',
  data => ({
    data
  })
)

export const exportSerpCheckerResults = Action(name + '/EXPORT_SERP_CHECKER_RESULTS', payload => ({
  payload
}))

export const exportSerpCheckerResultsSuccess = Action(
  name + '/EXPORT_SERP_CHECKER_RESULTS_SUCCESS',
  data => ({
    data
  })
)

export const exportSerpCheckerResultsFailure = Action(
  name + '/EXPORT_SERP_CHECKER_RESULTS_FAILURE',
  error => ({
    error
  })
)

export const getSerpCheckerHistory = Action(name + '/GET_SERP_CHECKER_HISTORY', historyId => ({
  historyId
}))

export const getSerpCheckerHistorySuccess = Action(
  name + '/GET_SERP_CHECKER_HISTORY_SUCCESS',
  data => ({
    data
  })
)

export const getSerpCheckerHistoryFailure = Action(
  name + '/GET_SERP_CHECKER_HISTORY_FAILURE',
  error => ({
    error
  })
)

export const loadSerpCheckerPrevious = Action(name + '/LOAD_SERP_CHECKER_PREVIOUS', historyId => ({
  historyId
}))

export const loadSerpCheckerPreviousSuccess = Action(
  name + '/LOAD_SERP_CHECKER_PREVIOUS_SUCCESS',
  data => ({
    data
  })
)

export const loadSerpCheckerPreviousFailure = Action(
  name + '/LOAD_SERP_CHECKER_PREVIOUS_FAILURE',
  error => ({
    error
  })
)

export const resetResults = Action(name + '/RESET_SERP_CHECKER_RESULTS')

export const deleteKeywords = Action(name + '/DELETE_SERP_CHECKER_RESULTS_KEYWORDS', historyId => ({
  historyId
}))

export const deleteKeywordsSuccess = Action(
  name + '/DELETE_SERP_CHECKER_RESULTS_KEYWORDS_SUCCESS',
  data => ({
    data
  })
)

export const deleteKeywordsFailure = Action(
  name + '/DELETE_SERP_CHECKER_RESULTS_KEYWORDS_FAILURE',
  error => ({
    error
  })
)
